// extracted by mini-css-extract-plugin
export default {"button":"Ppdwr4C7ygKVWmohNPlq","icon":"MBZdldxpfnlG9a6ESiCK"};